module.exports = __webpack_public_path__ + "static/img/lg-archive-img-03@t.51bb01a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/lg-archive-img-03@t.jpg
// module id = EBQf
// module chunks = 0